<script>
import documentMixin from "@/mixins/documentMixin";
import { mapActions } from "vuex";

export default {
  mixins: [documentMixin],
  data() {
    return {
      preloader: false,
      size: 300,
      preview_front: null,
      preview_back: null,
      preview_selfie: null,
      preview_proff_of_address: null,
      image_paths: {},
      currentStatus: null
    };
  },
  props: {
    documentType: {
      type: String,
      required: true
    },
    paths: {
      type: Object,
      required: true
    }
  },
  methods: {
    ...mapActions("documents", ["setPaths", "sendDocumentImage"]),

    isSelfie() {
      return this.paths.selfie != undefined;
    },

    isProffOfAddress() {
      return this.paths.proffOfAddress != undefined;
    },

    async changePath(event, type) {
      const file = event.target.files[0];

      let data = new FormData();

      this.image_paths[type] = URL.createObjectURL(file);

      data.append("upload_preset", "documents");
      data.append("file", file);

      await this.submitUploadDocumentPicture(data, type);
    },

    async submitUploadDocumentPicture(payload, type) {
      this.preloader = true;
      try {
        let picture = await this.sendDocumentImage(payload);

        this.paths[type] = picture;

        let documentPath = {
          documentType: this.documentType,
          paths: this.paths
        };

        this.setPaths(documentPath);
      } catch (e) {
        this.$toast.error(e);
      }

      this.preloader = false;
    },

    docType(type) {
      return {
        front: "Frente",
        back: "Verso"
      }[type];
    }
  },
  mounted() {
    let documentPath = {
      documentType: this.documentType,
      paths: this.paths
    };
    this.setPaths(documentPath);
    this.image_paths = this.paths;
  }
};
</script>

<template>
  <div>
    <div class="images">
      <div class="image-group" v-for="(path, type) in image_paths" :key="type">
        <span class="image-type" v-if="Object.keys(image_paths).length > 1">{{
          docType(type)
        }}</span>

        <label
          v-if="image_paths[type] != undefined && image_paths[type] != ''"
          class="image"
        >
          <input
            type="file"
            class="hidden"
            :id="type + '_' + path"
            @change="changePath($event, type)"
            accept=".jpg, .jpeg, .png"
          />
          <img :src="image_paths[type]" :width="size" />
          <div class="overlay"></div>
        </label>

        <div v-else class="container">
          <form enctype="multipart/form-data" novalidate>
            <div class="dropbox">
              <input
                type="file"
                :disabled="preloader"
                :id="type + '_' + path"
                @change="changePath($event, type)"
                accept=".jpg, .jpeg, .png"
                class="input-file"
              />
              <p v-if="preloader">
                Fazendo upload da foto...
              </p>
              <p v-else>
                Arraste a foto aqui<br />
                ou clique para escolher
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
    <v-slider
      v-model="size"
      class="align-self-stretch"
      min="300"
      max="400"
      step="1"
    ></v-slider>
  </div>
</template>

<style scoped>
.container {
  height: 100%;
  padding: 5px;
}

.container form {
  height: 100%;
}

.dropbox {
  outline: 2px dashed grey;
  outline-offset: -10px;
  background: #eee;
  opacity: 0.5;
  color: rgb(68, 61, 61);
  padding: 10px 10px;
  height: 100%;
  min-height: 300px;
  min-width: 250px;
  cursor: pointer;
  transition: opacity 0.5s;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.input-file {
  height: 100%;
  width: 100%;
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.dropbox:hover {
  opacity: 1;
}

.dropbox p {
  font-size: 1.2em;
  text-align: center;
}

.hidden {
  display: none;
}

.images {
  display: flex;
  justify-content: space-around;
}

.image {
  width: 40%;
  height: 40%;
  cursor: pointer;
  align-content: center;
}

.image-group {
  display: flex;
  flex-direction: column;
  align-content: center;
}

.image-type {
  text-align: center;
  font-weight: 500;
}

.photo img {
  width: 90%;
  height: 50%;
  object-position: center;
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Documents/DocumentPath.vue